import React from "react";
import { ConsentBannerScreenPosition } from "../../../../../../common/service/server/dto/CMPSettingsDto";
import { ConsentSettingRow } from "../../../consentBanner/ConsentSettingRow";
import { ConsentOptionCards } from "../../../consentBanner/ConsentOptionCards";
import { BannerThumbnail } from "../../../consentBanner/ConsentThumbnails";

export const SCREEN_POSITION_LABELS: Record<ConsentBannerScreenPosition, string> = {
  [ConsentBannerScreenPosition.BOTTOM_LEFT]: "Bottom left",
  [ConsentBannerScreenPosition.BOTTOM_CENTER]: "Bottom center",
  [ConsentBannerScreenPosition.BOTTOM_RIGHT]: "Bottom right",
  [ConsentBannerScreenPosition.MIDDLE_CENTER]: "Center",
};

const POSITIONS = [
  ConsentBannerScreenPosition.BOTTOM_LEFT,
  ConsentBannerScreenPosition.BOTTOM_CENTER,
  ConsentBannerScreenPosition.BOTTOM_RIGHT,
  ConsentBannerScreenPosition.MIDDLE_CENTER,
];

export const ConsentBannerScreenPositionRow = () => {
  return (
    <ConsentSettingRow
      title="Screen position"
      helpText="Where the banner opens on your site. Bottom left is most common."
    >
      <ConsentOptionCards
        field="bannerScreenPosition"
        ariaLabel="Screen position"
        columns={2}
        options={POSITIONS.map((position) => ({
          value: position,
          label: SCREEN_POSITION_LABELS[position],
          preview: <BannerThumbnail position={position} />,
        }))}
      />
    </ConsentSettingRow>
  );
};
